import { Grid } from '@mui/material_modern'

import { useGridApiRef } from '@mui/x-data-grid-pro_modern'
import UsersGrid from 'components/generic/datagrid/UsersGrid'
import { useMemo, useState } from 'react'
import { useGetGsUserListQuery } from 'services/gsUsers'
import { FILTER_OPTION_TYPES } from 'utils/constants'

enum SORTABLE_USER_FIELDS {
  NAME = 'name',
  EMAIL = 'email',
  GREENSPARK_ROLE = 'greensparkRole',
}

const UsersSettingsContainer = () => {
  const apiRef = useGridApiRef()

  const [paginationOptions, setPaginationOptions] = useState({ page: 1, pageSize: 30 })
  const [filter, setFilter] = useState({
    search: '',
    userStatuses: ['ACTIVE', 'INACTIVE'],
    sort: {
      field: SORTABLE_USER_FIELDS.NAME,
      ascending: true,
    },
  })

  const {
    data: usersData,
    isLoading,
    isFetching,
  } = useGetGsUserListQuery({
    page: paginationOptions.page,
    pageSize: paginationOptions.pageSize,
    filter: JSON.stringify(filter),
  })

  const handlePageChange = pageNumber => {
    setPaginationOptions({ ...paginationOptions, page: pageNumber + 1 })
  }
  const handlePageSizeChange = newPageSize => {
    setPaginationOptions({ ...paginationOptions, pageSize: newPageSize })
  }
  const additionalFilterOptions = useMemo(() => {
    return [
      {
        type: FILTER_OPTION_TYPES.MULTI_SELECT,
        name: 'userStatuses',
        label: 'Active/Inactive Status',
        options: [
          { id: 'ACTIVE', name: 'Active' },
          { id: 'INACTIVE', name: 'Inactive' },
        ],
        defaultValue: ['ACTIVE', 'INACTIVE'],
        width: '200px',
      },
    ]
  }, [])

  return (
    <Grid p={3} sx={{ height: '100%' }} container flexDirection="column">
      <UsersGrid
        rows={usersData?.Items || []}
        loading={isLoading || isFetching}
        useBackendSortAndFilter
        filter={filter}
        setFilter={setFilter}
        additionalFilterOptions={additionalFilterOptions}
        apiRef={apiRef}
        paginationMode="server"
        rowCount={usersData?.totalResultsCount || 0}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        pageSize={paginationOptions.pageSize}
      />
    </Grid>
  )
}

export default UsersSettingsContainer
